import {Form, FormField, FormSubmitHandler, Separator} from 'platform/components';
import {Grid, GridItem, VStack} from 'platform/foundation';

import {useGetWarehousesQuery} from '@dms/api/warehouse';
import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsFooter} from '@dms/settings/shared';
import {getOptionsFromWarehouses} from '@dms/shared';

import {WarehouseSpaceForm, WarehouseSpaceFormSchema} from '../types/WarehouseSpaceForm';

interface GeneralTabProps {
  onSubmit: FormSubmitHandler<WarehouseSpaceForm>;
  defaultValues?: WarehouseSpaceForm;
  isLoading?: boolean;
  isEditing?: boolean;
  isDisabled?: boolean;
}

export function GeneralTab(props: GeneralTabProps) {
  const {data: warehouses, isLoading: isWarehousesLoading} = useGetWarehousesQuery();

  return (
    <Form
      defaultValues={props.defaultValues}
      experimentalZodSchema={WarehouseSpaceFormSchema}
      onSubmit={props.onSubmit}
      shouldWatchForUnsavedChanges
      isDisabled={props.isDisabled}
    >
      {(control, _formApi, navigateWithoutBlocker) => (
        <VStack spacing={6}>
          <FormField
            type="switch"
            control={control}
            name="isActive"
            label={i18n.t('general.labels.active')}
            isDisabled={props.isLoading}
          />
          <Separator />
          <Grid columns={2}>
            <GridItem>
              <FormField
                type="text"
                control={control}
                name="name"
                label={i18n.t('general.labels.name')}
                isDisabled={props.isLoading}
                isRequired
              />
            </GridItem>
            <GridItem>
              <FormField
                type="multiChoice"
                control={control}
                name="assignWarehouses"
                label={i18n.t('entity.warehouse.labels.assignedWarehouses')}
                isDisabled={props.isLoading || isWarehousesLoading}
                options={getOptionsFromWarehouses(warehouses)}
                isRequired
              />
            </GridItem>
          </Grid>
          <SettingsFooter
            actions={[
              {
                type: 'button',
                title: props.isEditing
                  ? i18n.t('general.actions.discardChanges')
                  : i18n.t('general.actions.discard'),
                variant: 'secondary',
                onClick: () =>
                  props.isEditing
                    ? navigateWithoutBlocker(settingsRoutes.warehousesSpaces)
                    : navigateWithoutBlocker(-1),
                isDisabled: props.isLoading,
              },
              {
                type: 'form-button',
                control,
                title: i18n.t('general.labels.saveChanges'),
                buttonType: 'submit',
                isDisabled: props.isLoading,
              },
            ]}
          />
        </VStack>
      )}
    </Form>
  );
}
